import { render } from "./appPageActivity.vue?vue&type=template&id=4108900b&scoped=true"
import script from "./appPageActivity.vue?vue&type=script&lang=js"
export * from "./appPageActivity.vue?vue&type=script&lang=js"

import "./appPageActivity.vue?vue&type=style&index=0&id=4108900b&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4108900b"]])

export default __exports__